module.exports = (__parcel__import__("cBHFI")).then(() => parcelRequire('2geSQ'));